import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ArtistService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IArtist } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapArtistFromEntity, mapArtistFromModel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getArtist(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ArtistService();
        dispatch(toggleLoader());
        const response = await service.getArtist(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapArtistFromEntity(response.data.attributes["artist"] || {});

            if (!notFill) {
                dispatch(initialPageData<IArtist>(mapped));
            }
            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getArtistByLanguage(pageData: IArtist, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ArtistService();
        dispatch(toggleLoader());
        const response = await service.getArtist(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapArtistFromEntity(response.data.attributes["artist"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IArtist>(data));
            if (isOverride) {
                dispatch(updateArtist(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createArtist({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getArtist(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}

export function getArtistsForLocal(language: string): ThunkResult<Promise<IArtist[]>> {
    return async () => {
        const service = new ArtistService();
        const response = await service.getArtists({ page: 1, pageSize: 100, descending: false, language });
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapArtistFromEntity(item)
            );
            return mapped;
        }
        return [];
    };
}

export function getArtists(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ArtistService();
        dispatch(toggleLoader());
        const response = await service.getArtists(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapArtistFromEntity(item)
            );
            dispatch(initialPageData<IList<IArtist[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function createArtist(request: IArtist): ThunkResult<Promise<IArtist | null>> {
    return async (dispatch) => {
        const service = new ArtistService();
        dispatch(toggleLoader());
        const response = await service.createArtist(mapArtistFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapArtistFromEntity(response.data.attributes["artist"] || {});
        }
        return null;
    };
}

export function updateArtist(request: IArtist): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ArtistService();
        dispatch(toggleLoader());
        const response = await service.updateArtist(mapArtistFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteArtist(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ArtistService();
        dispatch(toggleLoader());
        const response = await service.deleteArtist(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}